//PLUGINS
// import { NgxPaginationModule                      } from 'ngx-pagination';
// import { PaginationModule                         } from 'ngx-bootstrap/pagination';
// import { ChecklistModule                          } from 'angular-checklist';
// import { CarouselModule                           } from 'ngx-bootstrap/carousel';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { FullCalendarModule                       } from 'ng-fullcalendar';
import { ColorPickerModule                        } from 'ngx-color-picker';
import { BsDatepickerModule, BsLocaleService      } from 'ngx-bootstrap/datepicker';
import { TimepickerModule                         } from 'ngx-bootstrap/timepicker';
import { ModalModule                              } from 'ngx-bootstrap/modal';
import { AccordionModule                          } from "ng2-accordion";

import { TypeaheadModule                          } from 'ngx-bootstrap/typeahead';
import { OrderModule                              } from 'ngx-order-pipe';
import { ToastrModule                             } from 'ngx-toastr';
import { APP_ROUTING                              } from './app.routes';
import { HashLocationStrategy, LocationStrategy   } from '@angular/common';
import { NgForm,FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { CommonModule                             } from '@angular/common';
import { NgModule                                 } from '@angular/core';
import { HttpModule                               } from '@angular/http';
import { TreeviewModule                           } from 'ngx-treeview';
import { TabsModule                               } from 'ngx-bootstrap/tabs';
import { BrowserAnimationsModule                  } from '@angular/platform-browser/animations';

//COMPONENETES
import { AppComponent                             } from './app.component';
import { LoginComponent                           } from './login/login.component';
import { HeaderComponent                          } from './main/header/header.component';
import { LateralComponent                         } from './main/lateral/lateral.component';
import { FooterComponent                          } from './main/footer/footer.component';
 import { MainComponent                           } from './main/main.component';
import { EnrutamientopqrComponent                 } from './main/enrutamientos/enrutamientopqr/enrutamientopqr.component';
import { EnrutamientoComponent                    } from './main/enrutamientos/enrutamiento/enrutamiento.component';
import { EnrutamientoPerfilComponent              } from './main/enrutamientos/enrutamiento-perfil/enrutamiento-perfil.component';
import { EnrutamientotercerosComponent            } from './main/enrutamientos/enrutamientoterceros/enrutamientoterceros.component';
import { EnrutamientofichastecnicasComponent      } from './main/enrutamientos/enrutamientofichastecnicas/enrutamientofichastecnicas.component';
import { EnrutamientoubicacionesComponent         } from './main/enrutamientos/enrutamientoubicaciones/enrutamientoubicaciones.component';
import { EnrutemientoinventarioComponent          } from './main/enrutamientos/enrutemientoinventario/enrutemientoinventario.component';
import { PerfilAccionesComponent                  } from './main/perfiles/perfil-acciones/perfil-acciones.component';
import { ModalpqrComponent                        } from './main/pqr/modalpqr/modalpqr.component';


//SERVICIOS
import { LoginGuard                               } from './servicios/login/login.guard';
import { NoLoginGuard                             } from './servicios/login/no-login.guard';
import { ConfigService                            } from './servicios/config/config.service';
import { KeyService                               } from './servicios/key.service';
import { UsuariosService                          } from './servicios/usuarios/usuarios.service';
import { AlertapqrService                         } from './servicios/pqr/alertapqr.service';
import { LogoEmpresaService                       } from './servicios/logo-empresa/logo-empresa.service';
import { PerfilesService                          } from './servicios/perfiles/perfiles.service';
import { ValidService                             } from './servicios/valid.service';
import { EventosJqueryService                     } from './servicios/eventos-jquery/eventos-jquery.service';
import { LoginempresaService                      } from './servicios/login/loginempresa.service';
import { HeaderService                            } from './servicios/header/header.service';
import { AgendamientoAppComponent                 } from './main/agendamiento-app/agendamiento-app.component';
import { CalendarioAnualComponent                 } from './main/calendarioAnual/calendarioAnual.component';
import { ExportarCsvService                       } from './servicios/exportar-csv/exportar-csv.service';
import { PrioridadService                         } from './servicios/pqr/prioridad.service';
import { FiltroAvanzadoModule                     } from './main/filtro-avanzado/filtro-avanzado.module';
import { CrudImagenesModule                       } from './main/crud-imagenes/crud-imagenes.module';
import { RastreoService                           } from './servicios/rastreo/rastreo.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    LateralComponent,
    FooterComponent,
    MainComponent,
    EnrutamientopqrComponent,
    EnrutamientoComponent,
    EnrutamientoPerfilComponent,
    EnrutamientotercerosComponent,
    EnrutamientofichastecnicasComponent,
    EnrutamientoubicacionesComponent,
    EnrutemientoinventarioComponent,
    PerfilAccionesComponent,
    AgendamientoAppComponent,
    CalendarioAnualComponent,
    ModalpqrComponent
  ],
  imports: [
    APP_ROUTING,
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    // FormControl,
    OrderModule,
    TabsModule.forRoot(),
    TreeviewModule.forRoot(),
    TypeaheadModule.forRoot(),
    FullCalendarModule,
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ColorPickerModule,
    AccordionModule,
    ModalModule.forRoot(),
    FiltroAvanzadoModule,
    CrudImagenesModule
  ],
  providers: [
    LoginGuard,
    NoLoginGuard,
    ConfigService,
    UsuariosService,
    KeyService,
    {provide: LocationStrategy, useClass:HashLocationStrategy},
    AlertapqrService,
    LogoEmpresaService,
    PerfilesService,
    ValidService,
    EventosJqueryService,
    LoginempresaService,
    HeaderService,
    ExportarCsvService,
    PrioridadService,
    RastreoService
  ],
  bootstrap: [AppComponent],
  exports: [
    AppComponent
  ],
  entryComponents: [
    AgendamientoAppComponent,
    CalendarioAnualComponent
  ]
})

export class AppModule { }



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/app.module.ts